import React, { useContext, useEffect } from "react";
import {
  getArticles,
  getStage,
  getCategories,
  getInstallation,
  getFeatures,
  getPdfs,
  getAttributes,
  getSupport,
} from "../directusAPI";
import { PDFFile } from "../global/types";
import { ArticlesContext } from "./ArticlesContext";
import { CategoriesContext } from "./CategoriesContext";
import { FeaturesContext } from "./FeaturesContext";
import { FilesContext } from "./FilesContext";
import { InstallationContext } from "./InstallationContext";
import { StageContext } from "./StageContext";
import { AttributesContext } from "./AttributesContext";
import { SupportContext } from "./SupportContext";

/**
 * Connects all APIs to the corresponding Contexts
 * ??? refactor to multiple Connectors (e.g. home, article, support)
 *
 * @returns Empty React Fragment
 */

export const APIConnector: React.FC = () => {
  const articlesContext = useContext(ArticlesContext);
  const categoriesContext = useContext(CategoriesContext);
  const stageContext = useContext(StageContext);
  const installationContext = useContext(InstallationContext);
  const featuresContext = useContext(FeaturesContext);
  const filesContext = useContext(FilesContext);
  const attributesContext = useContext(AttributesContext);
  const supportContext = useContext(SupportContext);

  useEffect(() => {
    fetchArticles();
    fetchCategories();
    fetchStage();
    fetchInstallation();
    fetchFeatures();
    fetchPdfs();
    fetchSupport();
    fetchAttributes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchInstallation = async () => {
    try {
      const installation = await getInstallation();

      installationContext.setInstallationItems(installation.data);
    } catch (err) {
      console.log("error getting installation data", err);
    }
  };

  const fetchArticles = async () => {
    try {
      const articles = await getArticles();

      articlesContext.setArticles(articles.data);
    } catch (err) {
      console.log("error getting articles", err);
    }
  };

  const fetchPdfs = async () => {
    try {
      const files = await getPdfs();
      const data = (files.data as unknown) as PDFFile[];

      filesContext.setPdfs(data);
    } catch (err) {
      console.log("error getting files", err);
    }
  };

  const fetchCategories = async () => {
    try {
      const categories = await getCategories();

      categoriesContext.setCategories(categories.data);
    } catch (err) {
      console.log("error getting categories", err);
    }
  };

  const fetchStage = async () => {
    try {
      const stage = await getStage();

      stageContext.setStageItems(stage.data);
    } catch (err) {
      console.log("error getting articles", err);
    }
  };

  const fetchFeatures = async () => {
    try {
      const features = await getFeatures();

      featuresContext.setFeatureItems(features.data);
    } catch (err) {
      console.log("error getting features", err);
    }
  };

  const fetchAttributes = async () => {
    try {
      const attributes = await getAttributes();

      attributesContext.setAttributesItems(attributes.data);
    } catch (err) {
      console.log("error getting attributes", err);
    }
  };

  const fetchSupport = async () => {
    try {
      const support = await getSupport();

      supportContext.setSupportItems(support.data);
    } catch (err) {
      console.log("error getting attributes", err);
    }
  };

  return <React.Fragment></React.Fragment>;
};
